import { render, staticRenderFns } from "./DiscountCouponsList.vue?vue&type=template&id=9995c93c&scoped=true&"
import script from "./DiscountCouponsList.vue?vue&type=script&lang=js&"
export * from "./DiscountCouponsList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCouponsList.vue?vue&type=style&index=0&id=9995c93c&lang=scss&scoped=true&"
import style1 from "./DiscountCouponsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9995c93c",
  null
  
)

export default component.exports